<template>
  <v-reports
    v-if="access.item_price_change_history"
    v-bind:headers="headers"
    v-bind:update="update"
    v-bind:data="data"
    itemsPriceHistory
    v-bind:num-pages="total"
    v-model="page"
    @change-pagination="changePagination"
    :data_loading="data_loading"
  >
    <template #search_text>
      <v-slide-x-reverse-transition>
        <v-btn icon @click="searchActivate">
          <v-icon>mdi-magnify</v-icon>
        </v-btn>
      </v-slide-x-reverse-transition>
      <v-slide-x-reverse-transition>
        <v-text-field
          v-model="search"
          ref="search_field"
          v-if="search_text"
          autofocus
          class="mt-3 pa-0"
          append-icon="mdi-close"
          @click:append="
            {
              (search_text = false), (search = ''), update(params);
            }
          "
          @change="update(params)"
          label="Search"
        ></v-text-field>
      </v-slide-x-reverse-transition>
    </template>
  </v-reports>
  <error404 v-else></error404>
</template>
<script>
export default {
  name: "ItemsPriceHistory",
  data: () => ({
    headers: [
      { text: "Date", value: "date", available: true },
      { text: "Item", value: "product_name", available: true },
      { text: "Store", value: "service_name", available: true },
      { text: "Employee", value: "employee_name", available: true },
      { text: "Adjustment", value: "adjustment", available: true },
      { text: "Stock after", value: "stock_after", available: true },
    ],
    data: [],
    page: 1,
    params: {},
    total: 0,
    data_loading: false,
    search_text: false,
    search: "",
  }),
  methods: {
    searchActivate() {
      this.search = "";
      this.search_text = true;
    },
    changePagination(page) {
      this.page = page;
      this.update(this.params);
    },
    async update(params) {
      this.data_loading = true;
      this.params = params;
      const start_date = new Date(params.start_date);
      const end_date = new Date(params.end_date);
      const invhistory = this.$communicator.then(
        this,
        await this.$communicator("items_price_change_history", {
          params: {
            service: params.service !== "" ? params.service : "",
            employee: params.employee._id !== "" ? params.employee._id : "",
            from: start_date.getTime(),
            to: end_date.getTime(),
            page: this.page,
            limit: 10,
            search: this.search,
          },
        })
      );
      if (invhistory) {
        this.total = invhistory.page;
        for (let i = 0; i < invhistory.data.length; i++) {
          const time = invhistory.data[i].date;
          invhistory.data[i].date = this.date_ddmmyy_hhmm(time);
          if (invhistory.data[i].type === "prices") {
            invhistory.data[i].new_price = "";
            if (!(invhistory.data[i].new_prices instanceof Array)) {
              invhistory.data[i].new_prices = [];
            }
            for (const p of invhistory.data[i].new_prices) {
              invhistory.data[i].new_price +=
                p.from +
                ";" +
                (p.price ? p.price.toLocaleString() : p.price) +
                ";  ";
            }
            invhistory.data[i].old_price = "";
            if (!(invhistory.data[i].old_prices instanceof Array)) {
              invhistory.data[i].old_prices = [];
            }
            for (const p of invhistory.data[i].old_prices) {
              invhistory.data[i].old_price +=
                p.from +
                ";" +
                (p.price ? p.price.toLocaleString() : p.price) +
                ";  ";
            }
          } else {
            invhistory.data[i].new_price = invhistory.data[i].new_price
              ? invhistory.data[i].new_price.toLocaleString()
              : invhistory.data[i].new_price;
            invhistory.data[i].old_price = invhistory.data[i].old_price
              ? invhistory.data[i].old_price.toLocaleString()
              : invhistory.data[i].old_price;
          }
        }
        this.data = invhistory.data;
      }
      this.data_loading = false;
    },
  },
  mounted() {
    this.headers = [
      { text: this.$t("date"), value: "date", available: true },
      { text: this.$t("item"), value: "product_name", available: true },
      { text: this.$t("store"), value: "service_name", available: true },
      { text: this.$t("employee"), value: "employee_name", available: true },
      { text: this.$t("old_price"), value: "old_price", available: true },
      { text: this.$t("new_price"), value: "new_price", available: true },
    ];
    for (const index in this.headers) {
      this.headers[index]["sortable"] = false;
    }
  },
  beforeMount() {
    this.access = this.$store.state.access;
  },
};
</script>
